import React from 'react'
import ReactDOM from 'react-dom'
// import {useStrict} from 'mobx';
import { Provider,inject, observer} from 'mobx-react'
import { BrowserRouter as Router } from 'react-router-dom'
import './index.css'
import stores from './stores'
import App from './App'
import * as registerServiceWorker from './registerServiceWorker'
import { LocaleProvider } from 'antd';
// import zhCN from 'antd/lib/locale-provider/zh_CN';
import './flexible'
import './commonButtonStyle.css'
import MobxIntlProviderChild from "./components/MobxIntlProviderChild";
// useStrict(true);

//国际化组件
const MobxIntlProvider = inject('localeStore')(observer(MobxIntlProviderChild))

ReactDOM.render(
        <Provider {...stores}>
            <MobxIntlProvider>
            <Router basename="/">
                <App/>
            </Router>
            </MobxIntlProvider>
        </Provider>,
    document.getElementById('root'),
)

registerServiceWorker.unregister()



// WEBPACK FOOTER //
// ./src/index.js